// WebKit 26 expone `document.createElement` (y algunos métodos de `customElements`)
// como propiedades OWN de solo lectura (`writable: false, configurable: true`). El
// polyfill @ungap/custom-elements —necesario porque WebKit no soporta customized
// built-in elements (`is="..."`)— las parchea por asignación directa
// (`document.createElement = fn`), que en strict mode lanza
// "Attempted to assign to readonly property" y aborta el pack entero, dejando la
// página sin ningún control mejorado (selects, steppers, ranges caen a nativo).
//
// `Object.defineProperty` sí funciona sobre esas props (son `configurable`), así que
// las redefinimos como writable ANTES de importar el polyfill para que su asignación
// directa tenga éxito. En navegadores donde ya son writable (Chrome/Firefox) esto es
// inocuo: reescribe la prop con su mismo valor. Debe importarse antes del polyfill.
export const makeWritable = (target, prop) => {
  if (!target) return
  const descriptor = Object.getOwnPropertyDescriptor(target, prop)
  if (descriptor && descriptor.writable === false && descriptor.configurable) {
    Object.defineProperty(target, prop, { ...descriptor, writable: true })
  }
}

makeWritable(document, 'createElement')
for (const method of ['define', 'get', 'whenDefined', 'upgrade']) {
  makeWritable(self.customElements, method)
}
